<template>
    <footer id="main-footer" class="p-3">
        <div class="container-fluid">
            <div class="row">
                <div class="col pr-5 pl-5">
                    <component
                        :is="active_footer_component"
                        :section="section"
                    ></component>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import {defineComponent, shallowRef} from "vue";
import FooterTickets from "./FooterTickets";

const FooterTicketComponent = shallowRef(FooterTickets);

export default defineComponent({
    name: "Footer",

    data() {
        return {
            footer_ticket: FooterTickets,
            route_name: "",
            good_footer: "",
            active_footer_component: null,
        }
    },

    methods: {
        chooseFooter() {
            if (this.section !== "home") {
                this.active_footer_component = FooterTicketComponent;
            }
        },

        init() {
            this.chooseFooter();
        }
    },

    mounted: function mounted() {

        this.init();
    },

    props: {
        locale: String,
        section: String,
    },
})
</script>

<style scoped>

</style>
